import {configureStore} from '@reduxjs/toolkit';

import externalLinksReducer from './ducks/externalLinks';
import inferenceReducer from './ducks/inference';
import insightsReducer from './ducks/insights';
import uwmReducer from './ducks/uwm';

export const store = configureStore({
    reducer: {
        uwm: uwmReducer,
        inference: inferenceReducer,
        insights: insightsReducer,
        externalLinks: externalLinksReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const dispatch = store.dispatch.bind(store);
export const getState = store.getState.bind(store);
export const subscribe = store.subscribe.bind(store);
